import { computed } from 'vue';
import { useRoute } from '#app/composables/router';
import { findItem } from '#layers/data-model/utils/filters/index';
import { useWorkspaceSchemaStore } from '#layers/workspace/public';

export function useSchemaBasedOnRoute() {
	const route = useRoute();
	const schemaStore = useWorkspaceSchemaStore();

	const sourceIdOrName = computed(() => route.params.source as string | undefined);
	const collectionIdOrName = computed(() => route.params.collection as string | undefined);

	const dataSource = computed(() => findItem(schemaStore.dataSources, {
		_or: [
			{
				id: { _eq: sourceIdOrName.value },
			},
			{
				apiName: { _eq: sourceIdOrName.value },
			},
		],
	}) ?? null);

	const collection = computed(() => {
		if (!dataSource.value) return null;

		const matchedCollection = findItem(dataSource.value.collections, {
			_or: [
				{
					id: { _eq: collectionIdOrName.value },
				},
				{
					dbName: { _eq: collectionIdOrName.value },
				},
			],
		});

		return matchedCollection?.isSystem ? null : matchedCollection;
	});

	return {
		dataSource,
		collection,
	};
}
